<script>
  import { createEventDispatcher } from "svelte";
  import Markdown from "$lib/components/Markdown.svelte";
  import Icon from "$lib/components/Icon.svelte";

  export let id;
  export let name;
  export let type;
  export let label;
  export let error;
  export let autoComplete;
  export let required;
  export let binding;
  export let errorLabelId;

  const dispatch = createEventDispatcher();

  let val = "";

  function handleChange(ev) {
    dispatch("change", { value: ev.target.value, name: ev.target.name, id: ev.target.id });
  }

  function clearSearchInputValue() {
    val = "";
    dispatch("clear", { value: val, name, id });
    binding.focus();
    // dispatching "change" to reset the formState
    dispatch("change", { value: val, name, id });
  }
  if (required) {
    label = `${label} (Required)`;
  }
</script>

<!-- extra div makes both tags align with the submit button as one element -->
<div>
  <label for={id} class="relative left-8 font-bold text-left">
    <Markdown input={label} class="!text-size-12" />
  </label>
  <div class="flex flex-row">
    <input
      bind:this={binding}
      on:change={handleChange}
      on:input={(ev) => (type !== "search" ? "" : (val = ev.target.value))}
      value={val}
      {name}
      {required}
      {id}
      {type}
      {autoComplete}
      aria-invalid={!!error}
      aria-describedby={error ? errorLabelId : null}
      class="rounded-15 border bg-neutral-100 py-4 px-6 w-full mt-8 peer {error &&
        'invalid:border-error'}"
    />

    {#if val && type === "search"}
      <div class="h-[35px]">
        <button
          type="button"
          data-testid="clearInputButton"
          class="-ml-[35px] mt-[13px]"
          aria-label="clear input"
          on:click={clearSearchInputValue}
        >
          <Icon type="close" size="md" />
        </button>
      </div>
    {/if}
  </div>
</div>
